const searchPhraseReducer = (state = 0, action ) => {
  switch(action.type) {
    case "addPhrase":
      return state = action.payload;
    default: 
      return state;
  }
}

export default searchPhraseReducer;
